import { useCallback, useEffect, useState } from "react"
import {
    apiDeleteListMaintainScheduler,
    apiGetAccountAffApiCurrent,
    apiGetAccountDataSponsorCurrent,
    apiGetAccountVDSCurrent,
    apiGetProviderDataSponsorCurrent,
    apiGetProviderDsPostpaidCurrent,
    apiGetMethodSelectProviderCurrent,
    apiGetListMaintainScheduler,
    apiGetListPackageDataCodes,
    apiGetListPackageDataSponsor,
    apiGetListPartner,
    apiGetProviderCurrent,
    apiGetStatusIgnoreWriteAuditLog,
    apiGetStatusMaintain
} from "../../api"
import {Alert, Button, Card, Col, Divider, Input, Modal, Row, Space, TableProps, Tabs, Tag, Typography} from "antd"
import { ArrowRightOutlined } from '@ant-design/icons'
import { WHILELIST_ACCOUNT } from "../../config/constants"
import { formatEndTime, formatUnixTime } from "../../utils/entity-utils"
import { useSelector } from "react-redux"
import { authSelector } from "../../redux/slices/authSlice"
import { PartnerList } from "../../interfaces/list-partner.interface"
import { toastError, toastSuccess } from "../../utils/toast"
import {mapCompanyAccounts, ScopeMaintain, mapMantenanceScope} from "../../assets/constants/constants"
import ModalMaintain from "./ModalMaintain"
import ModalAccountDataSponsor from "./ModalAccountDataSponsor"
import ModalAccountAffapi from "./ModalAccountAffapi"
import ModalProvider from "./ModalProvider"
import ModalAccountVDS from "./ModalAccountVDS"
import ModalProviderDataSponsor from "./ModalProviderDataSponsor"
import ModalProviderDsPostpaid from "./ModalProviderDsPostpaid"
import ModalMethodSelectProvider from "./ModalMethodSelectProvider"
import ModalAuditLog from "./ModalAuditLog"
import ModalCreateMaintenanceScheduler from "./ModalCreateMaintenanceScheduler"
import ModalViewMaintenanceScheduler from "./ModalViewMaintenanceScheduler"
import ModalViewCurrentSchedulers from "./ModalViewCurrentSchedulers"
import CustomTable from "../../components/table"


const initCustomer = {
    partners: [],
    total: 0
}

export default function SystemPage() {
    const [canUpdate, setCanUpdate] = useState(false)
    const authState = useSelector(authSelector);
    const { account } = authState;
    const [maintainSchedulers, setMaintainSchedulers] = useState({ maintainSchedulers: [], total: 0 });
    const [maintainValue, setMaintainValue] = useState({currentMaintainSchedulers: []});
    const [providerValue, setProviderValue] = useState('');
    const [modalMaintain, setModalMaintain] = useState(false);
    const [accountDataSponsorValue, setAccountDataSponsorValue] = useState('');
    const [accountAffapiValue, setAccountAffapiValue] = useState('');
    const [accountVDSValue, setAccountVDSValue] = useState('');
    const [providerDataSponsorValue, setProviderDataSponsorValue] = useState('');
    const [providerDsPostpaidValue, setProviderDsPostpaidValue] = useState('');
    const [methodSelectProviderValue, setMethodSelectProviderValue] = useState('');
    const [auditLogValue, setAuditLogValue] = useState('');
    const [modalAccountDataSponsor, setModalAccountDataSponsor] = useState(false);
    const [modalAccountAffapi, setModalAccountAffapi] = useState(false);
    const [modalAccountVDS, setModalAccountVDS] = useState(false);
    const [modalProviderDataSponsor, setModalProviderDataSponsor] = useState(false);
    const [modalProviderDsPostpaid, setModalProviderDsPostpaid] = useState(false);
    const [modalMethodSelectProvider, setModalMethodSelectProvider] = useState(false);
    const [modalProvider, setModalProvider] = useState(false);
    const [modalAuditLog, setModalAuditLog] = useState(false);
    const [modalCreateScheduler, setModalCreateScheduler] = useState(false);
    const [modalViewScheduler, setModalViewScheduler] = useState<any>({ isOpen: false, data: null });
    const [modalViewCurrentSchedulers, setModalViewCurrentSchedulers] = useState(false);
    const [modalDeleteScheduler, setModalDeleteScheduler] = useState<any>({ isOpen: false, data: null });
    const [otpConfirm, setOtpConfirm] = useState('');
    const [customers, setCustomers] = useState<PartnerList>(initCustomer)
    const [sponsors, setSponsors] = useState<any>({})
    const [codes, setCodes] = useState<any>({})

    const columns: TableProps<any>['columns'] = [
        // {
        //     key: 'id',
        //     title: "id",
        //     dataIndex: 'id',
        // },
        {
            key: 'name',
            title: "Tên lịch trình",
            dataIndex: 'name',
        },
        {
            key: 'scopeType',
            title: "Phạm vi bảo trì",
            render: (_, data) => data.scopeType ? mapMantenanceScope[data.scopeType as ScopeMaintain] : '-',
        },
        {
            key: 'startTime',
            title: "Thời gian bắt đầu",
            dataIndex: 'startTime',
        },
        {
            key: 'endTime',
            title: "Thời gian kết thúc",
            render: (_, data) => data.expireTime ? formatEndTime(data.startTime, data.expireTime) : '-',
        },
        {
            key: 'expireTime',
            title: "Thời gian bảo trì",
            dataIndex: 'expireTime',
            render: expireTime => expireTime ? formatUnixTime(expireTime) : '-',
        },
        {
            key: 'note',
            title: "Ghi chú",
            dataIndex: 'note',
        },
        // {
        //     key: 'createdAt',
        //     title: "createdAt",
        //     dataIndex: 'createdAt',
        // },
        {
            key: 'createdBy',
            title: "Nhân sự",
            dataIndex: 'createdBy',
        },
        {
            key: 'action',
            title: "Chức năng",
            render: (_, data) => (
                <Space>
                    <Button onClick={() => setModalViewScheduler({ isOpen: true, data })} type="default">
                        Xem
                    </Button>
                    <Button onClick={() => setModalDeleteScheduler({ isOpen: true, data })} danger>
                        Xoá
                    </Button>
                </Space>
            )
        },
    ]


    const fetchApiGetListPartner = useCallback(async () => {
        try {
            const resCustomers = await apiGetListPartner()
            if (resCustomers.data.partners != null) {
                resCustomers.data.partners = resCustomers.data.partners.filter((item: any) => !mapCompanyAccounts[item.cpCode])
                setCustomers(resCustomers.data)
            } else {
                setCustomers(initCustomer)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchDataSponsor = useCallback(async () => {
        try {
            const resSponsors = await apiGetListPackageDataSponsor({size: 300, page: 1})
            if (resSponsors.data != null) {
                const listPackages = {packages: resSponsors.data.packages.map((item: any) => item.package)}
                setSponsors(listPackages)
            } else {
                setSponsors({})
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchDataCode = useCallback(async () => {
        try {
            const resCodes = await apiGetListPackageDataCodes()
            if (resCodes.data.dataCodes != null) {
                setCodes(resCodes.data)
            } else {
                setCodes({})
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchSchedules = useCallback(async () => {
        try {
            const resp = await apiGetListMaintainScheduler()
            if (resp.data !== null) {
                setMaintainSchedulers(resp.data)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchMaintain = useCallback(async () => {
        try {
            const resp = await apiGetStatusMaintain()
            if (resp.data !== null) {
                setMaintainValue(resp.data)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchProvider = useCallback(async () => {
        try {
            const resp = await apiGetProviderCurrent()
            if (resp.data?.value !== null) {
                setProviderValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchAccountDataSponsor = useCallback(async () => {
        try {
            const resp = await apiGetAccountDataSponsorCurrent()
            if (resp.data?.value !== null) {
                setAccountDataSponsorValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchAccountAffapi = useCallback(async () => {
        try {
            const resp = await apiGetAccountAffApiCurrent()
            if (resp.data?.value !== null) {
                setAccountAffapiValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchAuditLog = useCallback(async () => {
        try {
            const resp = await apiGetStatusIgnoreWriteAuditLog()
            if (resp.data?.value !== null) {
                setAuditLogValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchAccountVDS = useCallback(async () => {
        try {
            const resp = await apiGetAccountVDSCurrent()
            if (resp.data?.value !== null) {
                setAccountVDSValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchProviderDataSponsor = useCallback(async () => {
        try {
            const resp = await apiGetProviderDataSponsorCurrent()
            if (resp.data?.value !== null) {
                setProviderDataSponsorValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchProviderDsPostpaid = useCallback(async () => {
        try {
            const resp = await apiGetProviderDsPostpaidCurrent()
            if (resp.data?.value !== null) {
                setProviderDsPostpaidValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchMethodSelectProvider = useCallback(async () => {
        try {
            const resp = await apiGetMethodSelectProviderCurrent()
            if (resp.data?.value !== null) {
                setMethodSelectProviderValue(resp.data.value)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const checkWhilelistAccount = useCallback(() => {
        const listWhilelistAccounts = WHILELIST_ACCOUNT?.split(',')
        if (listWhilelistAccounts?.includes(account.username)) {
            setCanUpdate(true)
        }
    }, [account.username])

    useEffect(() => {
        checkWhilelistAccount()
        fetchMaintain()
        fetchProvider()
        fetchAccountDataSponsor()
        fetchAccountAffapi()
        fetchAuditLog()
        fetchAccountVDS()
        fetchProviderDataSponsor()
        fetchProviderDsPostpaid()
        fetchMethodSelectProvider()
        fetchSchedules()
        fetchApiGetListPartner()
        fetchDataSponsor()
        fetchDataCode()
    }, [checkWhilelistAccount, fetchMaintain, fetchProvider, fetchAccountDataSponsor, fetchAccountAffapi, fetchAuditLog, fetchAccountVDS, fetchProviderDataSponsor, fetchProviderDsPostpaid, fetchMethodSelectProvider, fetchSchedules, fetchApiGetListPartner, fetchDataSponsor, fetchDataCode])

    const renderTag = (value: string, isActive = true) => (
        <Tag color={isActive ? "green" : "red"}>
            <h3 style={{ margin: 0, padding: 4 }}>{value}</h3>
        </Tag>
    )

    const renderMaintain = () => {
        if (maintainValue.currentMaintainSchedulers.length > 0) {
            return renderTag(`Đang bảo trì`, false)
        }
        return renderTag('Đang hoạt động')
    }

    const renderAccountDataSponsor = () => {
        switch (accountDataSponsorValue) {
            case 'data_sponsor':
                return renderTag('SANN')
            case 'datasponsor_zynet':
                return renderTag('Zynet')
            default:
                return renderTag('Không tìm thấy', false)
        }
    }

    const renderAccountAffapi = () => {
        switch (accountAffapiValue) {
            case 'aff_sann':
                return renderTag('SANN')
            case 'aff_zynet':
                return renderTag('Zynet')
            default:
                return renderTag('Không tìm thấy', false)
        }
    }

    const renderAuditLog = () => {
        if (auditLogValue === 'true') {
            return renderTag('Đã tắt', false)
        }
        return renderTag('Đang bật')
    }

    const renderAccountVDS = () => {
        if (accountVDSValue === 'vds-data-sponsor') {
            return renderTag(accountVDSValue)
        }
        return renderTag('Không tìm thấy', false)
    }

    const renderProviderDataSponsor = () => {
        switch (providerDataSponsorValue) {
            case 'data_sponsor':
                return renderTag('Viettel TT')
            case 'vds':
                return renderTag('VDS')
            default:
                return renderTag('Không tìm thấy', false)
        }
    }

    const renderProviderDsPostpaid = () => {
        switch (providerDsPostpaidValue) {
            case 'ds_postpaid':
                return renderTag('Viettel TT')
            case 'vds':
                return renderTag('VDS')
            default:
                return renderTag('Không tìm thấy', false)
        }
    }

    const renderMethodSelectProvider = () => {
        switch (methodSelectProviderValue) {
            case 'static':
                return renderTag('Static')
            case 'weightrandom':
                return renderTag('Weight Random')
            case 'loadbalance':
                return renderTag('Load Balance')
            default:
                return renderTag('Không tìm thấy', false)
        }
    }


    const handleDeleteScheduler = async () => {
        try {
            const resp = await apiDeleteListMaintainScheduler({ id: modalDeleteScheduler.data?.id, otpConfirm })
            if (resp.status === 200) {
                fetchSchedules()
                fetchMaintain()
                toastSuccess('Đã xoá lịch trình bảo trì hệ thống')
                setOtpConfirm('')
                setModalDeleteScheduler({ isOpen: false, data: null })
            }
        } catch (error) {
            toastError('Có lỗi xảy ra')
            console.log(error);
        }
    }


    return (
        <div>
            <Tabs
                defaultActiveKey="system-configuration"
                items={[
                    {
                        key: 'system-configuration',
                        label: 'Cấu hình hệ thống',
                        children: (
                            <div>
                                {/* System Health & Core Status Section */}
                                <Divider orientation="left">
                                    <Typography.Title level={4} style={{ margin: 0 }}>
                                        🔧 Trạng thái hệ thống & Giám sát
                                    </Typography.Title>
                                </Divider>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12} lg={8}>
                                        <Card title="Trạng thái hệ thống" bordered={true}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                {renderMaintain()}
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    {maintainValue.currentMaintainSchedulers && maintainValue.currentMaintainSchedulers.length > 0 && (
                                                      <Button
                                                        onClick={() => setModalViewCurrentSchedulers(true)}
                                                        type="default"
                                                      >
                                                          Xem bảo trì hiện tại
                                                      </Button>
                                                    )}
                                                    {canUpdate && <Button onClick={() => setModalMaintain(true)} type="primary">Tạo bảo trì</Button>}
                                                </div>
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <Card title="Trạng thái Audit Log" bordered={true}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                {renderAuditLog()}
                                                {canUpdate && <Button onClick={() => setModalAuditLog(true)} type="primary">Cập nhật</Button>}
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>

                                {/* Global Provider Configuration Section */}
                                <Divider orientation="left" style={{ marginTop: 32 }}>
                                    <Typography.Title level={4} style={{ margin: 0 }}>
                                        ⚙️ Cấu hình nhà cung cấp toàn cục
                                    </Typography.Title>
                                </Divider>
                                <Row gutter={[16, 16]}>
                                    {/* HIDDEN: Feature not enabled in current version*/}
                                    {/*<Col xs={24} sm={12} lg={8}>*/}
                                    {/*    <Card title="Nhà cung cấp cho hệ thống hiện tại" bordered={true}>*/}
                                    {/*        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>*/}
                                    {/*            {renderProvider()}*/}
                                    {/*            {canUpdate && <Button onClick={() => setModalProvider(true)} type="primary">Cập nhật</Button>}*/}
                                    {/*        </div>*/}
                                    {/*    </Card>*/}
                                    {/*</Col>*/}
                                    <Col xs={24} sm={12} lg={8}>
                                        <Card title="Phương thức chọn nhà cung cấp hiện tại" bordered={true}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                {renderMethodSelectProvider()}
                                                {canUpdate && <Button onClick={() => setModalMethodSelectProvider(true)} type="primary">Cập nhật</Button>}
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>

                                {/* Business Services Configuration Section */}
                                <Divider orientation="left" style={{ marginTop: 32 }}>
                                    <Typography.Title level={4} style={{ margin: 0 }}>
                                        📦 Cấu hình dịch vụ kinh doanh
                                    </Typography.Title>
                                </Divider>

                                {/* Shared VDS Resource Alert */}
                                {providerDataSponsorValue === 'vds' && providerDsPostpaidValue === 'vds' && (
                                  <Alert
                                    message="Cảnh báo"
                                    description="Cả hai dịch vụ (Đại trà và Upgrade) đang sử dụng cùng một tài khoản VDS. Bất kỳ thay đổi nào đối với tài khoản VDS sẽ ảnh hưởng đến cả hai dịch vụ."
                                    type="warning"
                                    showIcon
                                    style={{ marginBottom: 16 }}
                                  />
                                )}

                                {/* Data Sponsor (Đại trà) Service Group */}
                                <Card
                                    type="inner"
                                    style={{ marginBottom: 16, backgroundColor: '#f6ffed', border: '1px solid #b7eb8f' }}
                                    title={
                                        <Typography.Text strong style={{ fontSize: 16 }}>
                                            🚀 Dịch vụ bán gói đại trà
                                        </Typography.Text>
                                    }
                                >
                                    <Row gutter={[16, 16]} align="middle">
                                        <Col xs={24} lg={10}>
                                            <Card title="Nhà cung cấp bán gói đại trà hiện tại" bordered={true} size="small">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    {renderProviderDataSponsor()}
                                                    {canUpdate && <Button onClick={() => setModalProviderDataSponsor(true)} type="primary" size="small">Cập nhật</Button>}
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} lg={2} style={{ textAlign: 'center' }}>
                                            <ArrowRightOutlined style={{ fontSize: 24, color: '#52c41a' }} />
                                        </Col>
                                        <Col xs={24} lg={12}>
                                            {providerDataSponsorValue === 'vds' ? (
                                                <Card title="Tài khoản VDS đang hoạt động" bordered={true} size="small">
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        {renderAccountVDS()}
                                                        {canUpdate && <Button onClick={() => setModalAccountVDS(true)} type="primary" size="small">Cập nhật</Button>}
                                                    </div>
                                                </Card>
                                            ) : (
                                                <Card title="Tài khoản bán gói đại trà truyền thống" bordered={true} size="small">
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        {renderAccountDataSponsor()}
                                                        {canUpdate && <Button onClick={() => setModalAccountDataSponsor(true)} type="primary" size="small">Cập nhật</Button>}
                                                    </div>
                                                </Card>
                                            )}
                                        </Col>
                                    </Row>
                                </Card>

                                {/* Affapi (Upgrade) Service Group */}
                                <Card
                                    type="inner"
                                    style={{ marginBottom: 16, backgroundColor: '#e6f7ff', border: '1px solid #91d5ff' }}
                                    title={
                                        <Typography.Text strong style={{ fontSize: 16 }}>
                                            🚀 Dịch vụ bán gói upgrade
                                        </Typography.Text>
                                    }
                                >
                                    <Row gutter={[16, 16]} align="middle">
                                        <Col xs={24} lg={10}>
                                            <Card title="Nhà cung cấp bán gói upgrade hiện tại" bordered={true} size="small">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    {renderProviderDsPostpaid()}
                                                    {canUpdate && <Button onClick={() => setModalProviderDsPostpaid(true)} type="primary" size="small">Cập nhật</Button>}
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} lg={2} style={{ textAlign: 'center' }}>
                                            <ArrowRightOutlined style={{ fontSize: 24, color: '#1890ff' }} />
                                        </Col>
                                        <Col xs={24} lg={12}>
                                            {providerDsPostpaidValue === 'vds' ? (
                                                <Card title="Tài khoản VDS đang hoạt động" bordered={true} size="small">
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        {renderAccountVDS()}
                                                        {canUpdate && <Button onClick={() => setModalAccountVDS(true)} type="primary" size="small">Cập nhật</Button>}
                                                    </div>
                                                </Card>
                                            ) : (
                                                <Card title="Tài khoản bán gói upgrade truyền thống" bordered={true} size="small">
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        {renderAccountAffapi()}
                                                        {canUpdate && <Button onClick={() => setModalAccountAffapi(true)} type="primary" size="small">Cập nhật</Button>}
                                                    </div>
                                                </Card>
                                            )}
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                        ),
                    },
                    {
                        key: 'maintenance-schedule',
                        label: 'Lịch trình bảo trì',
                        children: (
                            <div>
                                {/* Maintenance Schedule Section */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 16 }}>
                                    <Button onClick={() => setModalCreateScheduler(true)} type="primary">
                                        Thêm lịch trình
                                    </Button>
                                </div>
                                <CustomTable
                                    namePage='lịch trình'
                                    columns={columns}
                                    dataSource={maintainSchedulers?.maintainSchedulers}
                                    total={maintainSchedulers?.total}
                                />
                            </div>
                        ),
                    },
                ]}
            />
            <ModalCreateMaintenanceScheduler
                open={modalCreateScheduler}
                onClose={() => setModalCreateScheduler(false)}
                onSuccess={fetchSchedules}
                customers={customers}
                codes={codes}
                sponsors={sponsors}
            />
            <Modal
                title="Xoá lịch trình bảo trị hệ thống"
                open={modalDeleteScheduler.isOpen}
                onOk={() => alert()}
                onCancel={() => setModalDeleteScheduler({ isOpen: false, data: null })}
                footer={[
                    <Button onClick={handleDeleteScheduler} type="primary">
                        Xoá
                    </Button>
                ]}>
                <p>Tên lịch trình: <b>{modalDeleteScheduler.data?.name}</b></p>
                <p>Thời gian bắt đầu: <b>{modalDeleteScheduler.data?.startTime}</b></p>
                <p>Thời gian kết thúc: <b>{modalDeleteScheduler.data?.expireTime ? formatEndTime(modalDeleteScheduler.data?.startTime, modalDeleteScheduler.data?.expireTime) : '-'}</b></p>
                <p>Thời gian bảo trì: <b>{modalDeleteScheduler.data?.expireTime ? formatUnixTime(modalDeleteScheduler.data?.expireTime) : '-'}</b></p>
                <p>Ghi chú: <b>{modalDeleteScheduler.data?.note}</b></p>
                <p>Nhân sự: <b>{modalDeleteScheduler.data?.createdBy}</b></p>
                <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
                <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
                <Divider />
            </Modal>
            <ModalMaintain
                isOpen={modalMaintain}
                setIsOpen={setModalMaintain}
                fetchData={fetchMaintain}
                customers={customers}
                codes={codes}
                sponsors={sponsors}
            />
            <ModalProvider
                isOpen={modalProvider}
                setIsOpen={setModalProvider}
                data={providerValue}
                fetchData={fetchProvider}
            />
            <ModalAccountDataSponsor
                isOpen={modalAccountDataSponsor}
                setIsOpen={setModalAccountDataSponsor}
                data={accountDataSponsorValue}
                fetchData={fetchAccountDataSponsor}
            />
            <ModalAccountAffapi
                isOpen={modalAccountAffapi}
                setIsOpen={setModalAccountAffapi}
                data={accountAffapiValue}
                fetchData={fetchAccountAffapi}
            />
            <ModalAuditLog
                isOpen={modalAuditLog}
                setIsOpen={setModalAuditLog}
                data={{ value: auditLogValue }}
                fetchData={fetchAuditLog}
            />
            <ModalAccountVDS
                isOpen={modalAccountVDS}
                setIsOpen={setModalAccountVDS}
                data={accountVDSValue}
                fetchData={fetchAccountVDS}
            />
            <ModalProviderDataSponsor
                isOpen={modalProviderDataSponsor}
                setIsOpen={setModalProviderDataSponsor}
                data={providerDataSponsorValue}
                fetchData={fetchProviderDataSponsor}
            />
            <ModalProviderDsPostpaid
                isOpen={modalProviderDsPostpaid}
                setIsOpen={setModalProviderDsPostpaid}
                data={providerDsPostpaidValue}
                fetchData={fetchProviderDsPostpaid}
            />
            <ModalMethodSelectProvider
                isOpen={modalMethodSelectProvider}
                setIsOpen={setModalMethodSelectProvider}
                data={methodSelectProviderValue}
                fetchData={fetchMethodSelectProvider}
            />
            <ModalViewMaintenanceScheduler
                open={modalViewScheduler.isOpen}
                onClose={() => setModalViewScheduler({ isOpen: false, data: null })}
                data={modalViewScheduler.data}
            />
            <ModalViewCurrentSchedulers
                open={modalViewCurrentSchedulers}
                onClose={() => setModalViewCurrentSchedulers(false)}
                currentSchedulers={maintainValue.currentMaintainSchedulers || []}
                onViewDetail={(scheduler) => setModalViewScheduler({ isOpen: true, data: scheduler })}
                onDelete={(scheduler) => {
                    setModalDeleteScheduler({ isOpen: true, data: scheduler });
                    setModalViewCurrentSchedulers(false);
                }}
            />
        </div>
    )
}
